<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2 mt-5 content" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import Api from '@/api';
import store from '@/store';
import filterObject from '@/util/lang';

export default {
  name: 'About',
  data() {
    return {
      content: '',
    };
  },
  created() {
    this.getContent();
    store.watch(
      state => state.lang,
      () => {
        this.getContent();
      },
    );
  },
  methods: {
    getContent() {
      Api.getContentAbout()
        .then(page => filterObject(page, store.getters.lang))
        .then(page => {
          this.content = page.content;
        });
    },
  },
};
</script>

<style lang="scss">
.content {
  img {
    display: block;
    max-width: 60%;
    margin: 0 auto;
  }
}
</style>
